import { useState } from "react";

import { ByBuildingTable } from "./ByBuildingTable";
import { AssetDetail } from "../AssetDetail/AssetDetail";

export const ByBuilding = ({isList, setIsList}) => {
  const [id, setId] = useState();

  return (
    <div>
      {
        isList ? (
          <ByBuildingTable
            setIsList={setIsList}
            setId={setId}
          />
        ) : (
          <AssetDetail
            id={id}
            setIsList={setIsList}
          />
        )
      }
    </div>
  )
}
